import {useTranslation as useTranslationBase} from 'react-i18next';
import {useSelector} from 'react-redux';
import {selectShowKeys} from '../store/slices/translationToggleSlice';
import type {i18n} from 'i18next';

interface TranslationResponse {
    t: (key: string | string[], options?: any) => string;
    i18n: i18n;
    ready: boolean;
}

export function useTranslationWithKeys(): TranslationResponse {
    const showKeys = useSelector(selectShowKeys);
    const {t, i18n, ready} = useTranslationBase();

    const tWithKeys: TranslationResponse['t'] = (key, options): string => {
        if (showKeys) {
            if (Array.isArray(key)) {
                return key[0];
            }
            return key as string;
        }
        const result = t(key, options);
        return typeof result === 'string' ? result : String(result);
    };

    return {
        t: tWithKeys,
        i18n,
        ready,
    };
}
